module.exports = __webpack_public_path__ + "media/student_v2/assets/images/Information-756569e8fe7f7956f1b24d5aab2ca672.png";